module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/28_e8fb445811245263cf6c3b05e2c1de16.jpg";